import React, { Component } from 'react'
import { Container } from 'react-bootstrap'
import AsideNavbar from '../../components/navbars/AsideNavbar'
import Navbars from '../../components/navbars/Navbars'

import * as Cookies from "es-cookie"
import { withRouter } from "react-router-dom";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

import CBSEFoundationSection from '../components/cbse_foundation/cbseFoundationSection';

class CBSEFoundation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            toggled: isMobile == true && Cookies.get("institution_id") == 30 
                ? "wrapper" 
                : Cookies.get("toggle")
        }
    }

    menuToggler = () => {
        const toggled = this.state.toggled;
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    render() {

        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        let studentGlobals = "";
        if (JSON.parse(localStorage.getItem("studentglobals")) != "") {
            studentGlobals = JSON.parse(localStorage.getItem("studentglobals"));
        }
        else {
            this.props.history.push("/student/login");
        }

        // ⭐ Get class number from route param
        const classId = this.props.match.params.id;

        let chapterData = [
            {"subject_id": "1", "chapter_name": "Number System" },
            {"subject_id": "1", "chapter_name": "Algebra Basics" },
            {"subject_id": "1", "chapter_name": "Geometry Fundamentals" }
        ];

        return (
            <div className={this.state.toggled}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>

                <div className="main-wrapper">
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper">
                        <CBSEFoundationSection classId={classId}    chapterData={chapterData} />
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter((CBSEFoundation));
